export var BASE_TAG = 'inline-flex items-center h-24 rounded-5 font-caption';
export var LINK_TAG_TYPES = {
  light: /*#__PURE__*/"".concat(BASE_TAG, " text-base-lighter border border-solid border-gray-main"),
  dark: /*#__PURE__*/"".concat(BASE_TAG, " text-base-lighter bg-base-lighter-24"),
  'primary-light': /*#__PURE__*/"".concat(BASE_TAG, " text-white bg-primary-lighter"),
  'primary-dark': /*#__PURE__*/"".concat(BASE_TAG, " text-white bg-primary-lighter")
};
export var TEXT_TAG_DEFAULT = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-white bg-purple-lighter");
export var TEXT_TAG_RED = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-white bg-red-main");
export var TEXT_TAG_YELLOW = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-base-main bg-yellow-main");
export var TEXT_TAG_GREEN = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-base-main bg-green-main");
export var GREEN_STATE_TAG = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-base-main bg-green-main");
export var YELLOW_STATE_TAG = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-base-main bg-yellow-main");
export var ORANGE_STATE_TAG = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-white bg-orange-main");
export var RED_STATE_TAG = /*#__PURE__*/"".concat(BASE_TAG, " px-8 text-white bg-red-main");
export var TAGS = {
  link: LINK_TAG_TYPES,
  text: {
    "default": TEXT_TAG_DEFAULT,
    red: TEXT_TAG_RED,
    yellow: TEXT_TAG_YELLOW,
    green: TEXT_TAG_GREEN
  },
  state: {
    green: GREEN_STATE_TAG,
    yellow: YELLOW_STATE_TAG,
    orange: ORANGE_STATE_TAG,
    red: RED_STATE_TAG
  }
};